import { FILTER_TYPES } from 'components/FilterPod';
import { FILTER_VOUCHER_TYPES } from '../components/Columns';
export const STATUS_OPTIONS = [
  {
    value: true,
    label: 'فعال',
  },

  {
    value: false,
    label: 'غیرفعال',
  },
];
const filters = () => [
  {
    title: 'نام بن',
    label: 'نام',
    keyName: 'name',
    query: 'name',
    id: 3398,
    value: null,
    filterType: FILTER_TYPES.text,
    filterProps: {},
  },

  {
    title: 'حساب تفصیلی',
    label: 'حساب تفصیلی',
    keyName: 'guildCode',
    query: 'guildCode',
    id: 3411,
    value: null,
    filterType: FILTER_TYPES.select,
    filterProps: {
      options: [],
    },

  },
  {
    title: 'نوع بن',
    label: 'نوع',
    keyName: 'type',
    query: 'type',
    id: 3400,
    value: null,
    filterType: FILTER_TYPES.select,
    filterProps: {
      options: FILTER_VOUCHER_TYPES
        ? Object.keys(FILTER_VOUCHER_TYPES)?.map((v) => ({
          label: FILTER_VOUCHER_TYPES[v],
          value: v,
        }))
        : [],
    },

  },

  {
    title: 'وضعیت',
    label: 'وضعیت',
    keyName: 'active',
    query: 'active',
    id: 3401,
    value: null,
    filterType: FILTER_TYPES.select,
    filterProps: {
      options: STATUS_OPTIONS,
    },
  },
  {
    title: 'وضعیت استفاده',
    label: 'وضعیت استفاده',
    keyName: 'used',
    query: 'used',
    id: 3405,
    value: null,
    filterType: FILTER_TYPES.select,
    filterProps: {
      options: [
        {
          label: 'استفاده شده',
          value: 1,
        },
        {
          label: 'استفاده نشده',
          value: 0,
        },
      ],
    },
  },
];

export default filters;
